import { create as n } from "zustand";
import { devtools as c, persist as a } from "zustand/middleware";
const i = (o) => {
  const t = o;
  return t.use = {}, Object.keys(t.getState()).forEach((e) => {
    t.use[e] = () => t((r) => r[e]);
  }), t;
}, p = (o, t = {}) => {
  const { name: e, devtoolsOptions: r } = t;
  return i(
    n(c(o, { name: e, ...r }))
  );
}, S = (o, t) => {
  const { name: e, persistOptions: r, ...s } = t;
  return p(a(o, { name: e, ...r }), {
    name: e,
    ...s
  });
};
export {
  S as createPersistentStore,
  p as createStore,
  i as createStoreSelectors
};
